

$(document).ready(function () {
    let productJSON = window.productJson; // Get product JSON (Make sure this exists)

    if (!productJSON || !productJSON.variants) {
        // console.error("Product JSON is missing or incorrect!");
        return;
    }

    function updateSwatchAvailability(selectedColor) {
        console.log("Selected Color:", selectedColor);

        $("[data-swatch-index]").each(function () {
            let $el = $(this);
            let swatchOption = $el.data("swatch-option");

            // Convert swatchOption to string safely
            if (swatchOption === undefined || swatchOption === null) {
                console.warn("Invalid swatch option:", swatchOption);
                return;
            }
            swatchOption = swatchOption.toString().toLowerCase();

            // Check if at least one available variant matches both selectedColor and swatchOption
            let isAvailable = productJSON.variants.some(variant => {
                let variantOptions = variant.options.map(option => option.toString().toLowerCase());
                return (
                    variant.available &&
                    variantOptions.includes(selectedColor.toString().toLowerCase()) &&
                    variantOptions.includes(swatchOption)
                );
            });

            // Add or remove "sold-out" class based on availability
            if (!isAvailable) {
                $el.addClass("sold-out");
              $(".swatch--color").removeClass("sold-out");
            } else {
                $el.removeClass("sold-out");
            }
        });
    }

    // 1️⃣ **On Window Load - Check Initial Active Swatch**
    $(window).on("load", function () {
        let initialSwatch = $(".swatch--color.swatch--active").data("swatch-option");
        if (initialSwatch) {
            updateSwatchAvailability(initialSwatch);
        }
    });

    // 2️⃣ **On Clicking a Swatch - Update Availability**
    $(".swatch--color").on("click", function () {
        $(".swatch--color").removeClass("swatch--active"); // Remove active class from all swatches
        $(this).addClass("swatch--active"); // Add active class to clicked swatch

        let selectedColor = $(this).data("swatch-option");
        updateSwatchAvailability(selectedColor);
    });
});



$(document).ready(function () {
    $(".product-section-custom-apx").each(function () {
        let $productSection = $(this);
        let productJSON = $productSection.data("product");

        if (!productJSON || !productJSON.variants) {
            console.error("Product JSON is missing or incorrect in section!");
            return;
        }

        function updateSwatchAvailability(selectedColor) {
            $productSection.find("[data-swatch-option]").each(function () {
                let $el = $(this);
                let swatchOption = $el.data("swatch-option");

                if (!swatchOption) return;
                swatchOption = swatchOption.toString().toLowerCase();

                let isAvailable = productJSON.variants.some(variant => {
                    let variantOptions = variant.options.map(option => option.toString().toLowerCase());
                    return (
                        variant.available &&
                        variantOptions.includes(selectedColor.toLowerCase()) &&
                        variantOptions.includes(swatchOption)
                    );
                });

                if (!isAvailable) {
                    $el.addClass("sold-out");
                   $(".swatch--color").removeClass("sold-out");
                } else {
                    $el.removeClass("sold-out");
                }
            });
        }

        // On page load, check for the active swatch in each section
        $(window).on("load", function () {
            let initialSwatch = $productSection.find(".swatch--color.swatch--active").data("swatch-option");
            if (initialSwatch) {
                updateSwatchAvailability(initialSwatch);
            }
        });

        // Handle swatch click event in each section
        $productSection.find(".swatch--color").on("click", function () {
            $productSection.find(".swatch--color").removeClass("swatch--active");
            $(this).addClass("swatch--active");

            let selectedColor = $(this).data("swatch-option");
            updateSwatchAvailability(selectedColor);
        });
    });
});



